export default __webpack_public_path__ + "static/media/56.37dfe6c0.png";